import { mapGetters } from 'vuex';

export default {
  mounted() {
    this.showContent = true;
  },
  data() {
    return {
      showContent: false,
    };
  },
  computed: {
    ...mapGetters(['pagingUp', 'pagingDown']),
    showContentByPaging() {
      return this.pagingUp ? true : this.showContent;
    },
  },
};
